import { useContext } from 'react';
import { EntityManagerContext, EntityManagerContextValue } from '../../context/EntityManagerContext';
export function useEntityManager() {
  return useContext(EntityManagerContext);
}